import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
    const { slug } = useParams();

    const token =
        localStorage.getItem(`userTkn-${slug}`) ||
        sessionStorage.getItem(`userTkn-${slug}`);

    if (!token) {
        return <Navigate to={`/${slug}/auth`} />;
    }

    return children;
}
